import React, { Fragment, useState } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FBannerSpendResponsive from "../../components/FBannerSpendResponsive/FBannerSpend";
import FcardPaymentMethod from "../../components/FcardPaymentMethod/FcardPaymentMethod";
import FInput from "../../components/FInput/FInput";
import BARcode from "react-barcode-reader";
import FQuickAccessList from "../../components/FQuickAccessList/FQuickAccessList";

const StorePaymentScreen = ({ param }) => {
  const route = useNavigate();
  const arrayCategory3 = [
    {
      name: "7 Eleven",
      imageUrl: require("../../components/assets/images/7-eleven_logo.png"),
      km: "2km",
    },
    {
      name: "Recarga tu celular",
      imageUrl: require("../../components/assets/images/waltmart.png"),
      km: "3.7km",
    },
    {
      name: "Comprar netflix",
      imageUrl: require("../../components/assets/images/superama.png"),
      km: "7.1km",
    },
    {
      name: "7 Eleven",
      imageUrl: require("../../components/assets/images/7-eleven_logo.png"),
      km: "2km",
    },
    {
      name: "Recarga tu celular",
      imageUrl: require("../../components/assets/images/waltmart.png"),
      km: "3.7km",
    },
    {
      name: "Comprar netflix",
      imageUrl: require("../../components/assets/images/superama.png"),
      km: "7.1km",
    },
  ];

  return (
    <>
      <div className="max-w-7xl mx-auto px-0 sm:px-6 md:px-8">
        <div className="py-4 border-0 border-dashed sm:p-3 max-h-screen mb-5">
          <div className="border-0 text-center grid grid-cols-1 justify-items-center">
            <div className="border-0 w-full rounded-2xl grid grid-cols-1 gap-0 px-10 py-5">
              <div className="border-0 col-span-1">
                <div className="w-full border-0 grid grid-cols-1 justify-items-center">
                  <img
                    src={require("../../components/assets/images/Barcode.png")}
                    className="w-32 sm:w-48"
                  />
                </div>
              </div>
              <div className="border-0 col-span-1 text-Secondary font-bold text-2xl pt-8">
                {"$200.00 USD"}
              </div>
              <div className="border-0 col-span-1 text-2xl font-bold pt-5">
                Referencia
              </div>
              <div className="border-0 col-span-1 text-xl">640509040147</div>
              <div className="border-0 col-span-1 text-2xl font-bold pt-5">
                Fecha límite de pago:
              </div>
              <div className="border-0 col-span-1 text-xl">Jul 22, 2022</div>
              <div className="border-0 col-span-1 grid items-center justify-center">
                <div className="w-72 sm:w-96">
                  <FInput type="botton" title="Finalizar" />
                </div>
              </div>
              <div className="border-0 col-span-1 text-sm font-bold pt-5 px-5">
                Puedes hacer el pago en estos establecimientos
              </div>
              <div class="flex overflow-x-auto space-x-8 w-1/1 ">
                <FQuickAccessList
                  productsShortcuts={arrayCategory3}
                  btn={false}
                />
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </>
  );
};

export default StorePaymentScreen;
